<template>
  <div class="statistics-container">
    TRAINS
    <TFlex style="width:100%" justify_content="flex-start">
      <v-card
        v-for="train in getUObjects({type: 'trains', ids: getUObject({type: 'projects', id: $route.params.project_id}).trains})"
        :key="train.id"
        width="250"
        class="mr-5"
        color="secondary"
      >
        <v-card-text>
          <div>{{train.name}}</div>
          <p class="text--primary">
            <span class="text-h1">{{Math.round($store.state.Ultra.trains[train.id].efficiency_value * 100) / 100}}</span>
            <br>
            <small class="text-h6">EFFICIENCY.value</small>
            <br>
            <span class="text-h1">{{Math.round($store.state.Ultra.trains[train.id].valuecreation_value * 100) / 100}}</span>
            <br>
            <small class="text-h6">VALUECREATION.value</small>
          </p>
        </v-card-text>
      </v-card>
    </TFlex>
    <TFlex v-if="$store.state.Ultra.projects[$route.params.project_id] && $store.state.Ultra.projects[$route.params.project_id].actual" style="flex-direction: column; width:100%" justify_content="flex-start">
      PROJECT
      <TFlex style="width:100%">
        <v-card
          width="250"
          class="mr-5"
          color="secondary"
        >
          <v-card-text>
            <p class="text--primary">
              <span class="text-h1">{{
                  $store.state.Ultra.projects[$route.params.project_id].actual.count_done +
                  $store.state.Ultra.projects[$route.params.project_id].actual.count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].actual.count_closed
                }}/{{
                  $store.state.Ultra.projects[$route.params.project_id].planned.done.total +
                  $store.state.Ultra.projects[$route.params.project_id].planned.checked.total
                  }}
              </span>
              <span class="text-h2">
                {{  percentage($store.state.Ultra.projects[$route.params.project_id].actual.count_done +
                $store.state.Ultra.projects[$route.params.project_id].actual.count_checked +
                $store.state.Ultra.projects[$route.params.project_id].actual.count_closed, $store.state.Ultra.projects[$route.params.project_id].planned.done.total +
                $store.state.Ultra.projects[$route.params.project_id].planned.checked.total).toFixed(1) }}%
              </span>
              <br>
              <small class="text-h6">PROJECT.done</small>
            </p>
          </v-card-text>
        </v-card>
      </TFlex>
      <TFlex style="width:100%">
        <v-switch
          v-model="showPlannedProgress"
          :label="showPlannedProgress ? 'Showing Planned Progress': 'Showing Total Progress'"
        ></v-switch>
      </TFlex>
      TRADES
      <TFlex v-if="$store.state.Ultra.projects[$route.params.project_id] && $store.state.Ultra.projects[$route.params.project_id].planned_twp" style="width:100%" wrap="wrap">
        <v-card
          v-for="(trade, trade_key) in filtered_planned_twp"
          :key="trade_key"
          width="250"
          class="mr-5 mb-5"
          color="secondary"
        >
          <v-card-text>
            <p class="text--primary" v-if="showPlannedProgress">
              <span class="text-h1">
                {{
                  $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_done +
                  $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_closed
                }}/{{
                  $store.state.Ultra.projects[$route.params.project_id].planned_twp[trade_key].count_done +
                  $store.state.Ultra.projects[$route.params.project_id].planned_twp[trade_key].count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].planned_twp[trade_key].count_closed
                }}
              </span>
              <span class="text-h2">
                {{  percentage($store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_done +
                $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_checked +
                $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_closed, $store.state.Ultra.projects[$route.params.project_id].planned_twp[trade_key].count_done +
                $store.state.Ultra.projects[$route.params.project_id].planned_twp[trade_key].count_checked +
                $store.state.Ultra.projects[$route.params.project_id].planned_twp[trade_key].count_closed).toFixed(1) }}%
              </span>
              <TWaggon
                :workpackage_count="1"
                :easter_egg="false"
                >
                <template #content>
                  <TWorkPackage
                    :workpackage_count="1"
                    :workpackage="getTWPObjectFromTradeKey(trade_key)"
                    :easter_egg="false"
                    :color="getTWPObjectFromTradeKey(trade_key).color"
                    >
                  </TWorkPackage>
                </template>
              </TWaggon>
            </p>
            <p class="text--primary" v-else>
              <span class="text-h1">
                {{
                  $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_done +
                  $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_closed
                }}/{{
                  $store.state.Ultra.projects[$route.params.project_id].wp_counts[trade_key]
                }}
              </span>
              <span class="text-h2">
                {{  percentage($store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_done +
                $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_checked +
                $store.state.Ultra.projects[$route.params.project_id].actual_twp[trade_key].count_closed, $store.state.Ultra.projects[$route.params.project_id].wp_counts[trade_key]).toFixed(1) }}%
              </span>
              <TWaggon
                :workpackage_count="1"
                :easter_egg="false"
                >
                <template #content>
                  <TWorkPackage
                    :workpackage_count="1"
                    :workpackage="getTWPObjectFromTradeKey(trade_key)"
                    :easter_egg="false"
                    :color="getTWPObjectFromTradeKey(trade_key).color"
                    >
                  </TWorkPackage>
                </template>
              </TWaggon>
            </p>
          </v-card-text>
        </v-card>
      </TFlex>
      TAKTAREAS
      <TFlex style="width:100%" justify_content="flex-start" wrap="wrap">
        <v-card
          v-for="(taktarea, taktarea_key) in filtered_planned_taktarea"
          :key="taktarea_key"
          width="250"
          class="mr-5 mb-5"
          color="secondary"
        >
          <v-card-text>
            <p class="text--primary" v-if="showPlannedProgress">
              <span class="text-h1">
                {{
                  $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_done +
                  $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_closed
                }}/{{
                  $store.state.Ultra.projects[$route.params.project_id].planned_taktarea[taktarea_key].count_done +
                  $store.state.Ultra.projects[$route.params.project_id].planned_taktarea[taktarea_key].count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].planned_taktarea[taktarea_key].count_closed
                }}
              </span>
              <span class="text-h2">
                {{  percentage($store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_done +
                $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_checked +
                $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_closed, $store.state.Ultra.projects[$route.params.project_id].planned_taktarea[taktarea_key].count_done +
                $store.state.Ultra.projects[$route.params.project_id].planned_taktarea[taktarea_key].count_checked +
                $store.state.Ultra.projects[$route.params.project_id].planned_taktarea[taktarea_key].count_closed).toFixed(1) }}%
              </span>
              <br>
              <span class="text-h6">{{taktarea_key.split(',')[0]}} ({{taktarea_key.split(',')[1]}})</span>
            </p>
            <p class="text--primary" v-else>
              <span class="text-h1">
                {{
                  $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_done +
                  $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_checked +
                  $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_closed
                }}/{{
                  $store.state.Ultra.projects[$route.params.project_id].taktarea_wp_counts[taktarea_key]
                }}
              </span>
              <span class="text-h2">
                {{  percentage($store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_done +
                $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_checked +
                $store.state.Ultra.projects[$route.params.project_id].actual_taktarea[taktarea_key].count_closed, $store.state.Ultra.projects[$route.params.project_id].taktarea_wp_counts[taktarea_key]).toFixed(1) }}%
              </span>
              <br>
              <span class="text-h6">{{taktarea_key.split(',')[0]}} ({{taktarea_key.split(',')[1]}})</span>
            </p>
          </v-card-text>
        </v-card>

      </TFlex>
    </TFlex>
    <TFlex v-if="$store.state.Ultra.projects[$route.params.project_id] && $store.state.Ultra.projects[$route.params.project_id].reporttradestatus" style="flex-direction: column; width:100%" justify_content="flex-start">
      <TFlex style="width:100%">
        <v-card style="width:100%">
          <h3>TRADE.status</h3>
          <BarChart :height="800" :chartData="$store.state.Ultra.projects[$route.params.project_id].reporttradestatus" />
        </v-card>
      </TFlex>
      <TFlex style="width:100%">
        <v-card style="width:50%;">
          <h3>STATUS.progress</h3>
          <LineChart :height="400" :chartData="$store.state.Ultra.projects[$route.params.project_id].reportstatusprogress" />
        </v-card>
        <v-card style="width:50%;">
          <h3>PROJECT.adherence</h3>
          <LineChart :height="400" :chartData="$store.state.Ultra.projects[$route.params.project_id].reportadherence" />
        </v-card>
      </TFlex>
    </TFlex>
  </div>
</template>
<script>
import store from '@/store/index'
// import { Line, HorizontalBar } from 'vue-chartjs';
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
//
// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
import LineChart from '@/components/LineChart.component.vue';
import BarChart from '@/components/HorizontalBarChart.component.vue';
import TFlex from '@/components/Taktify/TFlex.component.vue';
import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';

import { mapGetters} from 'vuex';

export default {
  components: {
    TFlex, //Line, HorizontalBar
    LineChart,
    BarChart,
    TWaggon,
    TWorkPackage
    // LineChart, HorizontalBarChart
  },
  name: 'ProjectStatistics',
  created(){
    store.dispatch('Project/requestProjectStats', this.$route.params.project_id).then(() => this.loaded = true);
  },
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject'
    ]),
    filtered_planned_twp(){
      let raw = this.$store.state.Ultra.projects[this.$route.params.project_id].planned_twp;
      return Object.keys(raw).filter(key => {
        return raw[key].count_done +
               raw[key].count_checked +
               raw[key].count_closed !== 0;
      }).reduce((obj, key) => {
        obj[key] = raw[key];
        return obj;
      }, {});
    },
    filtered_planned_taktarea(){
      let raw = this.$store.state.Ultra.projects[this.$route.params.project_id].planned_taktarea;
      return Object.keys(raw).filter(key => {
        return raw[key].count_done +
               raw[key].count_checked +
               raw[key].count_closed !== 0;
      }).reduce((obj, key) => {
        obj[key] = raw[key];
        return obj;
      }, {});
    }
  },
  data: function () {
    return {
      showPlannedProgress: true,
      loaded: false,
      stats_filter: '',
      colors: ['#CD5C5C','#FF69B4','#EEE8AA','#D8BFD8','#BA55D3','#6A5ACD',
      '#ADFF2F','#2E8B57','#20B2AA','#4169E1','#DEB887','#B8860B','#F0FFFF'],
      line_options: {
        scales: {
          yAxes: [{
          ticks: {
            min: 0,
            max: 100,
            stepSize: 5,
            reverse: false,
            beginAtZero: true
            }
          }]
        }
      },
      bar_options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              min: 0,
              max: 100,
              stepSize: 5,
              reverse: false,
              beginAtZero: true
              }
          }]
        },
      },
      adherence_options: {
        scales: {
          yAxes: [{
          ticks: {
            min: 70,
            max: 110,
            stepSize: 5,
            reverse: false,
            beginAtZero: true
            }
          }]
        },
        plugins: {
          autocolors: false,
          // annotation: {
          //   annotations: {
          //     box1: {
          //       // Indicates the type of annotation
          //       type: 'box',
          //       xMin: 1,
          //       xMax: 2,
          //       yMin: 50,
          //       yMax: 70,
          //       backgroundColor: 'rgba(255, 99, 132, 0.25)'
          //     }
          //   }
          // }
        }
      },
      dummy_data: {
        labels: ['A', 'B', 'C'],
        datasets: [
          {
            label: 'Adherence',
            data: [86, 78, 83],
            borderColor: 'rgb(75, 192, 192)',
            fill: false,
          }
        ]
      }
    };
  },
  methods: {
    updateStatsFilter(stats_filter){
      this.stats_filter = stats_filter;
    },
    filterStatsArr(arr){
      if (arr && arr.length) {
        if (this.stats_filter) {
          return arr.filter( obj => obj.label.includes(this.stats_filter.toUpperCase()));
        }
        return arr;
      }
      return null;
    },
    getColors(amount){
      return this.colors.slice(0, amount);
    },
    getTotal(stats){
      return Object.values(stats).reduce((a, b) => a + b, 0);
    },
    getTWPObjectFromTradeKey(trade_key){
      let arr = trade_key.split(',');
      return {
        color: arr[0],
        token: arr[1],
        icon: arr[2]
      }
    },
    percentage(partialValue, totalValue) {
       return (100 * partialValue) / totalValue;
    }
    // getCols(){
    //   if (this.$vuetify.breakpoint.smAndDown) {
    //     return 12;
    //   } else if(this.$vuetify.breakpoint.mdOnly) {
    //     return 6;
    //   } else {
    //     return 4;
    //   }
    // },
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  width: 90%;
  margin-left: 5%;
}
</style>
